import { atom, atomFamily } from 'recoil';

import { ObterResultadoDiaResponse } from './types';

export const searchTermState = atom({
  key: 'TradingList/searchTermState',
  default: '',
});

export const tradingListItemDetailState = atomFamily<
  ObterResultadoDiaResponse[],
  { idConta: number; sinacor: number; idContaSuperPNP: number }
>({
  key: 'TradingList/tradingListItemDetailState',
  default: [],
});
